/* eslint-disable no-negated-condition */
import moment from "moment";
import isEqual from "lodash/fp/isEqual";
import map from "lodash/fp/map";
import filter from "lodash/fp/filter";

class Controller {
  constructor($injector, Report, Lists, Events, PaymentCycle, CityHandler) {
    "ngInject";
    this.Report = Report;
    this.Events = Events;
    this.City = $injector.get("City");
    this.CityHandler = CityHandler;
    this.PaymentCycle = PaymentCycle;
    this.reportTypes = Lists.all.generateReportTypes;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.captainFinancesTypes = [
      "detailed_captain_finances",
      "summary_captain_finances",
    ];
    this.captainFinancesGroupByFields = [
      {
        name: "captain",
        title: "Captain",
      },
      {
        name: "contractor",
        title: "Contractor",
      },
    ];

    this.handleReportChange();

    this.PaymentCycle.getAll().$promise.then(
      (response) => {
        this.paymentCycles = response.hits;
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );

    const formatCities = (cities) =>
      map(({ _id, _source }) => ({
        _id,
        name: _source.name.toLowerCase(),
        title: _source.name,
        languages: _source.languages,
        active: _source.active,
      }))(cities);

    const isActive = (city) => city.active;

    this.City.getAll({ limit: 0 }).$promise.then(
      (response) => {
        this.cities = [...filter(isActive, formatCities(response.hits))];
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );

    this.city = this.CityHandler.get();
  }

  handleReportChange() {
    const forcedDisabledGPS = "captain_gps_force_enable";
    if (this.type) {
      this.isCaptainFinances = this.captainFinancesTypes.includes(this.type);
      this.isCaptainForcedDisabledGPS =
        this.type.localeCompare(forcedDisabledGPS) === 0;
      this.isPlanValidation = isEqual(
        this.type,
        "captain_plan_validation_report"
      );
    }
  }

  generateReport() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const message = { message: "Report has been sent to your email" };
    if (this.type) {
      const city = this.CityHandler.get();
      const from = moment(this.startDate)
        .utc()
        .startOf("day")
        .toDate()
        .toISOString();
      const to = moment(this.endDate).utc().endOf("day").toDate().toISOString();
      const dateParam = { from_date: from, to_date: to };
      let paymentParam = {};
      let captainForcedEnabledGPSParam = {};
      if (city) {
        const paymentCycleParam =
          this.paymentCycle && this.paymentCycle.length > 0
            ? { payment_cycles: map("_id")(this.paymentCycle) }
            : {};
        paymentParam = {
          city: city._id,
          ...paymentCycleParam,
          group_by: this.captainFinancesGroupBy,
        };
      }
      if (this.selectedCities) {
        captainForcedEnabledGPSParam = {
          cities: this.selectedCities.map((_city) => {
            return _city._id;
          }),
        };
      }

      let params = {};
      if (this.startDate && this.endDate) {
        params = dateParam;
      } else if (this.isCaptainFinances) {
        params = paymentParam;
      } else {
        params = captainForcedEnabledGPSParam;
      }
      if (params) {
        this.Report.generate(this.type, params).$promise.then(
          () => {
            this.Events.emit(showNotificationEvent, message);
          },
          (response) => this.Events.emit(this.errorEvent, response.data)
        );
      }
    } else if (this.isPlanValidation) {
      this.Report.generate(this.type).$promise.then(
        () => {
          this.Events.emit(showNotificationEvent, message);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/reportGenerator/reportGenerator.controller.js